var VALID_DOMAIN_SFX = ['ru', 'ua', 'com', 'com.tr', 'kz', 'by'];
export function getDomainSfx() {
    var validHostnameRe = /(^|.+\.)yandex\.(.+)$/;
    if (typeof window !== 'undefined' && window && window.location && window.location.hostname) {
        var match = window.location.hostname.match(validHostnameRe);
        if (match && VALID_DOMAIN_SFX.includes(match[2])) {
            return match[2];
        }
    }
    return 'ru';
}
export function fixDomainSfx(url, domainSfx) {
    if (!VALID_DOMAIN_SFX.includes(domainSfx)) {
        return url;
    }
    var validUrl = /^(https:\/\/trust(-test)?\.yandex)\.ru\//;
    return url.replace(validUrl, "$1." + domainSfx + "/");
}
var VALID_LANG_CODES = [
    'az', 'be', 'en', 'et', 'fi',
    'he', 'hy', 'ka', 'kk', 'ky',
    'lv', 'ro', 'ru', 'tr', 'uk', 'uz'
];
var DEFAULT_LANG_CODE = 'ru';
var DOMAIN_SFX_LANG_MAP = {
    by: 'be',
    ua: 'uk',
    com: 'en',
    kz: 'kk',
    'com.tr': 'tr'
};
export function verifyLang(_lang) {
    var lang = typeof _lang === 'string' ? _lang.toLowerCase() : '';
    if (VALID_LANG_CODES.includes(lang)) {
        return lang;
    }
    return DEFAULT_LANG_CODE;
}
export function langByDomainSfx(domainSfx) {
    if (DOMAIN_SFX_LANG_MAP[domainSfx]) {
        return verifyLang(DOMAIN_SFX_LANG_MAP[domainSfx]);
    }
    return DEFAULT_LANG_CODE;
}
